import React, {useEffect, useState} from 'react';
import Button from '../button';
import './index.css';

function Popup ({onClose, lv2, unClosable, className, theme, children, confirmBtn}) {

	const [isClosed, setIsClosed] = useState(false);
	const [isAppearing, setIsAppearing] = useState(true);

	useEffect(() => {
		const timer = setTimeout(() => {
			setIsAppearing(false);
			if (document.querySelector('.popup')) {
				if (document.querySelector('.popup').classList.contains('appearing')) {
					document.querySelector('.popup').classList.remove('appearing');
				}
			}
		}, 100);
		return () => clearTimeout(timer);
	}, []);

	const close = () => {

		if (onClose) {
			onClose();
			setIsClosed(true);
		} else {
			setIsClosed(true);
		}

	};

	if(!isClosed){
		return (
			<div
				className={`bg-popup${lv2 ? ' lv2' : ''}`}
				onClick={unClosable ? null : close}
			>
				<div
					onClick={(e) => e.stopPropagation()}
					className={`popup position-relative${isAppearing ? ' appearing' : ''}${className ? ` ${className}` : ''}${theme ? ` ${theme}` : ''}`}
				>
					{
						unClosable ? null : (
							<Button className='btn-link close' onClick={close}>
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
								     xmlns="http://www.w3.org/2000/svg">
									<path fill="currentColor" d="m2.74,23.59l-2.32,-2.32l9.27,-9.27l-9.27,-9.27l2.32,-2.32l9.27,9.27l9.27,-9.27l2.32,2.32l-9.27,9.27l9.27,9.27l-2.32,2.32l-9.27,-9.27l-9.27,9.27z" id="svg_1"/>
								</svg>
							</Button>
						)
					}
					{children}
					{
						confirmBtn && (
							<div className='text-center'>
								<Button className='btn-primary' onClick={close}>
									Ok
								</Button>
							</div>
						)
					}
				</div>
			</div>
		)
	} else {
		return null;
	}

}

export default Popup;

/*class Popup extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			isClosed: false
		};

		this.close = this.close.bind(this);
	}

	componentDidMount() {
		setTimeout(() => {
			if (document.querySelector('.popup')) {
				if (document.querySelector('.popup').classList.contains('appearing')) {
					document.querySelector('.popup').classList.remove('appearing');
				}
			}
		}, 100);
	}

	close() {

		if (this.props.onClose) {
			this.props.onClose();
			this.setState({isClosed: true});
		} else {
			this.setState({isClosed: true});
		}
		this.props.setDetailsForContactCard({})

	}

	render() {
		if (this.state.isClosed === false) {
			return (
				<div
					className={`bg-popup${this.props.lv2 ? ' lv2' : ''}`}
					onClick={this.props.unclosable ? null : this.close}
				>
					<div
						onClick={(e) => e.stopPropagation()}
						className={`popup position-relative appearing${this.props.className ? ` ${this.props.className}` : ''}${this.props.theme ? ` ${this.props.theme}` : ''}`}
					>
						{
							this.props.unclosable ? null : (
								<button className='close' onClick={this.close}>
									<svg width="34" height="34" viewBox="0 0 34 34" fill="none"
									     xmlns="http://www.w3.org/2000/svg">
										<path fillRule="evenodd" clipRule="evenodd"
										      d="M34 17C34 26.3888 26.3888 34 17 34C7.61116 34 0 26.3888 0 17C0 7.61116 7.61116 0 17 0C26.3888 0 34 7.61116 34 17ZM8.38383 25.6162C7.79804 25.0304 7.79804 24.0807 8.38383 23.4949L14.8787 17L8.38374 10.5051C7.79795 9.91932 7.79795 8.96957 8.38374 8.38378C8.96952 7.798 9.91927 7.798 10.5051 8.38378L17 14.8787L23.4949 8.38378C24.0807 7.798 25.0305 7.798 25.6163 8.38378C26.202 8.96957 26.202 9.91932 25.6163 10.5051L19.1213 17L25.6162 23.4949C26.202 24.0807 26.202 25.0304 25.6162 25.6162C25.0304 26.202 24.0806 26.202 23.4949 25.6162L17 19.1214L10.5052 25.6162C9.91936 26.202 8.96962 26.202 8.38383 25.6162Z"
										      fill="#FF1938"/>
									</svg>
								</button>
							)
						}
						{this.props.children}
						{
							this.props.confirmBtn && (
								<div className='text-center'>
									<Button className='btn-primary' onClick={this.close}>
										Ok
									</Button>
								</div>

							)
						}
					</div>
				</div>
			)
		} else {
			return null;
		}
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		setShowHowDoesItWorksPopup: (boolean) => {
			dispatch(showSupportDetailsPopup(boolean))
		},
		setDetailsForContactCard: (object) => dispatch(setDetailsForContactCard(object))
	}
};

export default withRouter(connect(null, mapDispatchToProps)(Popup));*/
